module.exports = __webpack_public_path__ + "9ef1759c58d4a04e82c40aaca48e1798.png";